import { formatDisplayDatesForSearch } from "../../../services/Utils";
import { Box, Chip, Tooltip, Typography } from "@mui/material";

export function ValueChicklet({
  index,
  searchVal,
  operator,
  onItemEdited,
  mode,
}) {
  let text;
  let searchValLength;
  let fullList;
  if (searchVal) {
    searchValLength = searchVal?.length;
    if (operator?.id === "between") {
      text = formatDisplayDatesForSearch(searchVal?.value);
    } else if (searchValLength > 0) {
      if (searchValLength > 1) {
        text = searchVal[0]?.value;
        fullList = searchVal.map((o) => o.value).join(", ");
      } else {
        text = searchVal[0].value;
      }
    } else {
      text = searchVal?.value;
    }
  }

  if (!text) {
    return null;
  }

  const handleClick = () => {
    if (mode !== "editValue" && mode !== "value") onItemEdited(index);
  };

  if (searchValLength > 1) {
    return (
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}
        onClick={handleClick}
      >
        <Typography variant="body2" component="span" sx={{ whiteSpace: "nowrap" }}>
          {text}
        </Typography>
        <Tooltip title={`Items : ${fullList}`} arrow>
          <Chip
            label={`+${searchValLength - 1}`}
            size="small"
            color="secondary"
            sx={{ cursor: "pointer", fontSize: "0.8125rem" }}
          />
        </Tooltip>
      </Box>
    );
  }

  return (
    <Typography
      variant="body2"
      component="span"
      onClick={handleClick}
      sx={{ whiteSpace: "nowrap", cursor: "pointer" }}
    >
      {text}
    </Typography>
  );
}
